<template>
  <div class="select">
      <select v-validate="'required'" v-bind:value="value" v-on:change="$emit('input', $event.target.value)" name="Store">
        <option/>
        <option v-for="store in stores" :key="store.url">{{store.url}}</option>
      </select>
      <p class="help is-danger" v-show="errors.has('Store')">
        {{ errors.first('Store') }}
      </p>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'StoreSelector',
  props: ['value'],
  data () {
    return {
      stores: []
    }
  },
  created () {
    axios.get('/api/stores').then(response => {
      this.stores = response.data
    })
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
